import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var Faq = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment faq on ComponentPresentationFaq {\n    Answer\n    Question\n  }\n"])));
export default Faq;